import { useEffect } from "react";
import { studentFetch, guardianFetch } from "../utils/authFetch";

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const HEARTBEAT_INTERVAL_MS = 60 * 1000; // 60 seconds

/**
 * Fires a fire-and-forget heartbeat to keep the session alive during
 * extended in-app activity (quiz solving, reading pages, etc.).
 *
 * @param {"student"|"guardian"} userType - which heartbeat endpoint to call
 * @param {boolean} enabled - if false, the hook does nothing (default true)
 */
export function useSessionHeartbeat(userType, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    if (userType !== "student" && userType !== "guardian") return undefined;

    const endpoint =
      userType === "student"
        ? `${API}/auth/student/session/heartbeat`
        : `${API}/auth/guardian/session/heartbeat`;

    const fetchFn = userType === "student" ? studentFetch : guardianFetch;

    const fire = () => {
      // Fire-and-forget. studentFetch/guardianFetch already handle 401 by
      // redirecting to the auth screen, so no extra error handling needed.
      fetchFn(endpoint, { method: "POST" }).catch(() => {
        // Network errors are silent — heartbeat is best-effort
      });
    };

    const intervalId = setInterval(fire, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [userType, enabled]);
}
